import React from 'react';
import AgentsSelectionControlled from 'components/organizations/agents/agent-selection-controlled';
import { Row } from 'components/common/grid';
import ControlledTextInput from 'components/common/form-controlled/controlled-text-input';
import type { VcsConnectionsForm } from 'components/organizations/vcs/vcs-connection-modal/access-card/use-connection-modal-access-card-form.hook';

export const VcsConnectionModalFormVcsAgent: React.FC<VcsConnectionsForm> = ({ vcsConnection, form }) => {
  return (
    <>
      <Row align="middle" justify="start">
        <ControlledTextInput
          inline
          width={100}
          mandatory
          label={{ id: `organization.settings.agents.vcs-connections-modal.connection.selfHosted.url` }}
          info={{ id: `organization.settings.agents.vcs-connections-modal.connection.selfHosted.url.info` }}
          name="url"
          form={form}
          disabled={vcsConnection?.url}
        />
      </Row>
      <Row align="middle" justify="start">
        <AgentsSelectionControlled
          form={form}
          css={{ width: '100%' }}
          mandatory
          label={{ id: 'organization.settings.agents.vcs-connections-modal.connection.selfHosted.agent-key' }}
          info={{ id: `organization.settings.agents.vcs-connections-modal.connection.selfHosted.agent-key.info` }}
          name={'vcsAgentKey'}
          shouldDisplaySaasAgent={false}
        />
      </Row>
    </>
  );
};
